module.exports = __webpack_public_path__ + "static/img/xj2.0c8813d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj2.jpg
// module id = ABCl
// module chunks = 1